import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const useUserTable = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({
    username: "",
    email: "",
    role: "",
    password: "",
  });

  const token = localStorage.getItem("authToken");

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/user/get-all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsers(response.data.recordset);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch users");
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchUsers();
  }, []);

  const editUser = (user) => {
    if (!user) return setEditingUser(null);
    setEditingUser(user);
    setEditForm({
      username: user.username,
      email: user.email,
      role: user.role,
      password: user.password,
    });
  };

  const handleInputChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const updateUser = async () => {
    try {
      await axios.put(
        `${API_URL}/api/user/update/${editingUser.id}`,
        editForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setEditingUser(null);

      setUsers(
        users.map((user) =>
          user.id === editingUser.id ? { ...user, ...editForm } : user,
        ),
      );
    } catch (err) {
      alert("Error while updating user");
    }
  };

  const deleteUser = async (id) => {
    if (!window.confirm("Are you sure you want to delete this user?")) {
      return;
    }

    try {
      await axios.delete(`${API_URL}/api/user/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUsers(users.filter((user) => user.id !== id));
    } catch (err) {
      alert("Error while deleting user");
    }
  };

  return {
    users,
    loading,
    error,
    editingUser,
    editForm,
    editUser,
    handleInputChange,
    updateUser,
    deleteUser,
  };
};
